import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { GenericDocLineDraftLockSerialNumberContainerModel } from "../../../../../../models";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class GenericDocLineDraftLockSerialNumberService extends BaseApiTemplateService<GenericDocLineDraftLockSerialNumberContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc-line/draft-lock-serial-numbers/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc-line/draft-lock-serial-numbers/backoffice-ep";
    this.httpClient = http;
  }

}
